import { ElementRef, Injectable } from '@angular/core';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DragService {
  public childConnectors: string[] = [];
  public parentConnectors: string[] = [];

  setChildConnectors(childRef: ElementRef) {
    this.childConnectors.push(childRef.nativeElement.id);
  }

  setParentConnectors(parentRef: ElementRef) {
    this.parentConnectors.push(parentRef.nativeElement.id);
  }

  getChildConnectors(): Observable<Array<string>> {
    return of(this.childConnectors);
  }

  getParentConnectors(): Observable<Array<string>> {
    return of(this.parentConnectors);
  }

  drop(event) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (!event.previousContainer.element.nativeElement.classList.contains('side-menu-dnd')) {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
    }
  }
}
